/**
 * Gate for frontend E2E Auth0 shortcuts.
 *
 * REACT_APP_E2E_AUTH_BYPASS is honored only when a non-production stage is
 * explicit. CRA `npm run build` always sets NODE_ENV=production, so the E2E
 * Docker image must also set REACT_APP_E2E_STAGE=test (see Dockerfile.e2e).
 *
 * Local `npm start` has NODE_ENV=development, so the flag alone is enough.
 * Firebase production builds fail closed even if the bypass flag is copied in.
 */

const ALLOWED_STAGES = new Set(["development", "test", "local"]);

function normalizedStage(): string {
  return (
    process.env.REACT_APP_E2E_STAGE ||
    process.env.NODE_ENV ||
    ""
  )
    .trim()
    .toLowerCase();
}

export function isE2eAuthBypassEnabled(): boolean {
  if (process.env.REACT_APP_E2E_AUTH_BYPASS !== "true") {
    return false;
  }
  return ALLOWED_STAGES.has(normalizedStage());
}
